import { jsx as _jsx } from "react/jsx-runtime";
import DeviceAcceptanceCard from '../Cards/DeviceAcceptanceCard';
/** @deprecated - No longer used */
function DeviceAcceptanceView(props) {
    const { contextCustomer } = props;
    return _jsx("div", { children: contextCustomer && _jsx(DeviceAcceptanceCard, { ...props }) });
}
export default DeviceAcceptanceView;
